import { updateObject } from '../../shared/utility';
import {
    GET_REPORT_START, GET_REPORT_SUCCESS, GET_REPORT_FAIL,
    SEND_SMS_START, SEND_SMS_SUCCESS, SEND_SMS_FAIL,
    GET_STATEMENT_START, GET_STATEMENT_SUCCESS, GET_STATEMENT_FAIL,
    GET_REPORT_DETAIL_START, GET_REPORT_DETAIL_SUCCESS, GET_REPORT_DETAIL_FAIL
} from '../actions/actionTypes';

const initialState = {
    report: null,
    error: null,
    message: null,
    loading: false,
    statement: null,
    reportDetail: null,
}

const getReportStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getReportSuccess = (state, action) => {
    return updateObject(state, { report: action.report, error: null, loading: false });
}

const getReportFail = (state, action) => {
    return updateObject(state, { error: action.error, loading: false });
}

const sendSmsStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const sendSmsSuccess = (state, action) => {
    return updateObject(state, { report: action.report, message: 'send sms success', error: null, loading: false });
}

const sendSmsFail = (state, action) => {
    return updateObject(state, { error: action.error, loading: false });
}

const getStatementStart = (state, action) => {
    return updateObject(state, { error: null, message: null, loading: true });
}

const getStatementSuccess = (state, action) => {
    return updateObject(state, { error: null, message: 'Get Statement Success', loading: false, statement: action.statement });
}

const getStatementFail = (state, action) => {
    return updateObject(state, { error: action.error, message: null, loading: false });
}

const getReportDetailStart = (state, action) => {
    return updateObject(state, { error: null, message: null, loading: true });
}

const getReportDetailSuccess = (state, action) => {
    return updateObject(state, { error: null, message: 'get report detail success', reportDetail: action.reportDetail });
}

const getReportDetailFail = (state, action) => {
    return updateObject(state, { error: action.error, message: null, reportDetail: null });
}

const reportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_REPORT_START:
            return getReportStart(state, action);
        case GET_REPORT_SUCCESS:
            return getReportSuccess(state, action);
        case GET_REPORT_FAIL:
            return getReportFail(state, action);
        case SEND_SMS_START:
            return sendSmsStart(state, action);
        case SEND_SMS_SUCCESS:
            return sendSmsSuccess(state, action);
        case SEND_SMS_FAIL:
            return sendSmsFail(state, action);
        case GET_STATEMENT_START:
            return getStatementStart(state, action);
        case GET_STATEMENT_SUCCESS:
            return getStatementSuccess(state, action);
        case GET_STATEMENT_FAIL:
            return getStatementFail(state, action);
        case GET_REPORT_DETAIL_START:
            return getReportDetailStart(state,action);
        case GET_REPORT_DETAIL_SUCCESS:
            return getReportDetailSuccess(state,action);
        case GET_REPORT_DETAIL_FAIL:
            return getReportDetailFail(state,action);
        default:
            return state;
    }
}

export default reportReducer;